// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__iO8LJ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__26O5o"};